export const lang = "en-US";


// WEBPACK FOOTER //
// ./src/consts.js